import { ReactNode } from 'react'

import {
	Box,
	LinkProps,
	Text,
	TextProps,
	Link as UILink
} from '@chakra-ui/react'

import { cn } from '@/shared/lib/cn'

interface LayoutProps {
	className?: string
	children?: ReactNode
}

// There are also redefined default props,
// just to make it clear, how these layout-components look

export const Body = ({ className, children }: LayoutProps) => {
	return <span className={cn('ts-6 text-gray-500', className)}>{children}</span>
}

export const Title = (props: TextProps) => (
	<Box
		as="span"
		textStyle="headline-4"
		color="gray.500"
		{...props}
	/>
)

export const Link = (props: LinkProps) => (
	<UILink
		color="gray.200"
		textDecoration="underline"
		{...props}
	/>
)

export const Address = (props: TextProps) => (
	<Text
		textStyle="body-text-4"
		color="gray.500"
		{...props}
	/>
)
